import React, { Component } from 'react'
import { connect } from 'react-redux'

import actions from '../actions'
import { isVoiceEnabled } from '../lib/config'
import ActiveCallCard from './ActiveCallCard'
import VoiceNotices from './VoiceNotices'

// Mounted once in the main layout (Layout.js), so the call card and the
// notices survive route changes. Mounting starts the voice session and
// unmounting stops it, so it never runs on the login page or on the
// logistic-command-center layout. Calls are placed from vehicle UIs
// (VehiclePhoneCall, VehicleCallButton), which read the session from redux.
class VoicePanel extends Component {
  componentDidMount() {
    if (isVoiceEnabled()) this.props.init()
  }

  componentWillUnmount() {
    if (isVoiceEnabled()) this.props.teardown()
  }

  render() {
    if (!isVoiceEnabled()) return null
    return (
      <>
        <ActiveCallCard />
        <VoiceNotices />
      </>
    )
  }
}

const mapDispatchToProps = {
  init: actions.init,
  teardown: actions.teardown,
}

export default connect(null, mapDispatchToProps)(VoicePanel)
